import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  ["About", "/about", "nav-link-about"],
  ["Ifa", "/ifa-consultations", "nav-link-ifa"],
  ["Fitness & Lifestyle", "/wellness-fitness", "nav-link-wellness"],
  ["Music", "/music-culture", "nav-link-music"],
  ["Sango", "/sango-experience", "nav-link-sango"],
  ["Shop Now", "/shop", "nav-link-shop"],
  ["Contact", "/contact", "nav-link-contact"],
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  return (
    <header className="site-header" data-testid="header-navbar">
      <div className="page-wrap header-inner">
        <Link className="brand-mark" to="/" data-testid="nav-brand-logo" aria-label="OBA OGUNLANO LLC home">
          <span className="brand-seal">O·O</span>
          <span className="brand-copy"><strong>OBA OGUNLANO</strong><span>Living wisdom / divine rhythm</span></span>
        </Link>
        <nav className="desktop-nav" data-testid="nav-desktop-links" aria-label="Primary navigation">
          <Link className="nav-link" to="/" data-testid="nav-link-home">Home</Link>
          {links.map(([label, href, testId]) => <Link key={href} className={`nav-link ${location.pathname === href ? "active" : ""}`} to={href} data-testid={testId}>{label}</Link>)}
        </nav>
        <Link className="client-access-link" to="/portal" data-testid="nav-client-portal-link">Client sign in</Link>
        <Link className="header-cta" to="/book-oba" data-testid="nav-cta-book-oba">Book Now</Link>
        <button className="menu-toggle" type="button" onClick={() => setOpen((value) => !value)} data-testid="nav-mobile-menu-toggle" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open}>
          {open ? <X size={19} /> : <Menu size={19} />}
        </button>
      </div>
      {open && <nav className="mobile-menu" data-testid="nav-mobile-menu-drawer" aria-label="Mobile navigation"><Link to="/" data-testid="mobile-link-home">Home</Link>{links.map(([label, href]) => <Link key={href} to={href} data-testid={`mobile-${href.slice(1).replaceAll("/", "-")}-link`}>{label}</Link>)}<Link to="/book-oba" data-testid="mobile-book-now-link">Book Now</Link><Link to="/portal" data-testid="mobile-client-portal-link">Client sign in</Link></nav>}
    </header>
  );
}
